import React, { useState, useRef, useEffect } from "react";
import { format, addDays, addWeeks, subWeeks, startOfWeek, endOfWeek, formatDistanceToNow } from "date-fns";
import { AgendaShift, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, ShiftsByUserQuery, ShiftsByUserQueryVariables } from "../../graphql/API";
import { useLazyQuery, useQuery } from "@apollo/client";
import { getAgendaUser, shiftsByUser } from "./queries";
import { useAuthContext } from "../../contexts/AuthContext";
import { Button, Container, Modal, Spinner, Stack } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai';
import { IoArrowRedoCircleOutline } from "react-icons/io5";
import i18n from "../../contexts/I18n"
import { useTranslation} from "react-i18next";
import { enUS, fr } from 'date-fns/locale';
import Cookies from "js-cookie";
import CustomModal from "../../components/Modals/CustomModal";
import { Pagination } from '@aws-amplify/ui-react';
import Sidebar from "../services/Sidebar/Sidebar";
import useDateService from "../services/DateService";
import { SHIFTS_PER_PAGE } from "../../config";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useNotification } from "../../contexts/NotificationProvider";
import useNotificationStorageService from "../services/NotificationStorageService";

const Agenda: React.FC = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  // PAGINATION
  const [pageTokens, setPageTokens] = React.useState([null]);
  const [totalPagination, setTotalPagination] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
  const [hasMorePages, setHasMorePages] = React.useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [shiftsState, setShiftsState] = useState([]);
  // NAVIGATION
  const navigate = useNavigate();
  const location = useLocation();
  // NOTIFICATION
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const shiftAcceptedCount = notificationContext?.shiftAcceptedCount;
  const setShiftAcceptedCount = notificationContext?.setShiftAcceptedCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const setConfirmShiftCount = notificationContext?.setConfirmShiftCount;
  const {updateNotificationModelCount} = useNotificationStorageService();
  // DATE SERVICES
  const {getTIMEZONE, getDateWithTimezone, getMondayOfWeek, getNextMonday, isNowGreater} = useDateService();
  // TIMEZONE SETTINGS
  const TIMEZONE = getTIMEZONE();
  //WEEK VIEW CALENDAR
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const listRef = useRef<HTMLDivElement | null>(null);
  // Calendar
  const [showMonthCalendar, setShowMonthCalendar] = useState(false);
  // shifts
  const monday = getMondayOfWeek(new Date());
  const nextMonday = getNextMonday(new Date());

  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser} = 
      useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
        {variables: {userId: AuthUserId}});

  const user = dataUser?.getAgendaUser;

  const [fetchShifts, {data, loading, error, refetch, fetchMore}] = useLazyQuery
    <ShiftsByUserQuery, ShiftsByUserQueryVariables>(shiftsByUser);
  // const [fetchData, {data, loading, error, refetch, fetchMore}] = useQuery
  //   <ShiftsByUserQuery, ShiftsByUserQueryVariables>
  //     (shiftsByUser, {variables: {
  //       userId: AuthUserId, 
  //       startAt: {gt: monday},//{gt: yesterday}, 
  //       limit: ITEMS_PER_PAGE,               
  //       // nextToken: pageTokens[pageTokens.length - 1],
  //       sortDirection: ModelSortDirection.ASC,
  //       filter: {
  //         stopAt: {lt: nextMonday},//{lt: tomorrow}, 
  //         confirmed: {eq: true},
  //         deleted: {ne: true}}}});

  // to reload each time
  useEffect(() => {
    setNotificationCount((notificationCount ?? 0) - 
      (confirmShiftCount ?? 0) - (shiftAcceptedCount ?? 0));
    updateNotificationModelCount('confirmShift', 0);
    updateNotificationModelCount('shiftAccepted', 0);
    setConfirmShiftCount(0);
    setShiftAcceptedCount(0);
  }, [location]);

  const getShifts = async (token: string) => { //date: Date, 
    const monday = getMondayOfWeek(new Date(currentWeek)); //+"T05:00:00.000Z"
    const nextMonday = getNextMonday(new Date(currentWeek)); //+"T05:00:00.000Z"));
    // getMondayOfWeek(new Date(defaultDate.split("T")[0]+"T05:00:00.000Z"));
    const now = getDateWithTimezone(new Date(currentWeek).toISOString(), TIMEZONE);
    // const monday = getMondayOfWeek(new Date(now.split("T")[0]+"T05:00:00.000Z")); //+"T05:00:00.000Z"
    // const nextMonday = getNextMonday(new Date(now.split("T")[0]+"T05:00:00.000Z")); //+"T05:00:00.000Z"));
    // const monday = getMondayOfWeek(new Date(currentWeek)); //+"T05:00:00.000Z"
    // const nextMonday = getNextMonday(new Date(currentWeek));
    // console.log('lol',getMondayOfWeek(now.split("T")[0]+"T05:00:00.000Z"));
    // console.log(nextMonday);
    // console.log('token', token);

    // return await refetch({
    //   userId: AuthUserId, 
    //   startAt: {gt: monday}, 
    //   limit: ITEMS_PER_PAGE,               
    //   nextToken: token,
    //   sortDirection: ModelSortDirection.ASC,
    //   filter: {
    //     stopAt: {lt: nextMonday}, 
    //     confirmed: {eq: true},
    //     deleted: {ne: true}}
    // });
    return await fetchShifts({variables: {
      userId: AuthUserId, 
      startAt: {gt: monday}, 
      limit: SHIFTS_PER_PAGE,               
      nextToken: token,
      sortDirection: ModelSortDirection.ASC,
      filter: {
        stopAt: {lt: nextMonday}, 
        confirmed: {eq: true},
        deleted: {ne: true}}
    }});
  }

  useEffect(() => {
    document.title = t('title.agenda');
    getShifts(pageTokens[pageTokens.length - 1]);
  }, []);

  useEffect(() => {
    getShifts(pageTokens[pageTokens.length - 1]);
  }, [currentWeek]);

  // PAGINATION
  useEffect(() => {
    if (data && data.shiftsByUser && !dontUpdateAnymore) {
      const newShifts = data.shiftsByUser.items;
      const newToken = data.shiftsByUser.nextToken;
  
      // console.log(newShifts);
      setShiftsState(newShifts);
      if (newToken) {
        setPageTokens((prevTokens) => [...prevTokens, newToken]); 
        setHasMorePages(true);
      } else {
        setHasMorePages(false); 
      }
    }
  }, [data]);

  useEffect(() => {
    if (hasMorePages) {
      setTotalPagination(pageTokens.length);
    } else {
      setTotalPagination(pageTokens.length - 1);
    }
  },[hasMorePages]);

  const handlePageChange = async (pageIndex: any) => {
    setDontUpdateAnymore(true);
    setCurrentPageIndex(pageIndex);

    const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
    if (selectedToken !== undefined) {
      const { data: { shiftsByUser: { items: newShifts, nextToken: newNextToken } } } = await getShifts(selectedToken);
      // console.log('the', newShifts);
      if (newShifts.length !== 0) {
        setShiftsState(newShifts);
        SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
        if (newNextToken && !pageTokens.includes(newNextToken)) {
          setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
        }
        // console.log(pageTokens);
      } else {
        if (hasMorePages) {
          setHasMorePages(false);
        }
      }
    }
  };
  
  const handleNextPage = async () => {
    setDontUpdateAnymore(true);
    const nextToken = pageTokens[currentPageIndex];

    if (nextToken) {
      const { data: { shiftsByUser: { items: newShifts, nextToken: newNextToken } } } = await getShifts(nextToken);

      // console.log('next', newShifts);
      if (newNextToken) {
        setShiftsState(newShifts);
        SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
        if (!pageTokens.includes(newNextToken)) {
          // console.log('pt',pageTokens);
            setPageTokens((prevTokens) => [...prevTokens, newNextToken]); // Ajoute le nouveau token
        }
        setCurrentPageIndex(currentPageIndex + 1);
      } else {
        if (newShifts.length > 0) {
          setShiftsState(newShifts);
          SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
          setCurrentPageIndex(currentPageIndex + 1);
          setHasMorePages(false);
        } else {
          if (hasMorePages) {
            setHasMorePages(false);
          }
        }
      }
      // console.log(pageTokens);

    } else {
      console.error("Next token is undefined or null");
    }
  };
    
  const handlePreviousPage = async () => {
    setDontUpdateAnymore(true);
    if (currentPageIndex > 1) {
      const prevToken = pageTokens[currentPageIndex - 2];

      const { data: { shiftsByUser: { items: prevShifts, nextToken: newNextToken } } } = await getShifts(prevToken);

      // console.log('prev', prevShifts);
      setShiftsState(prevShifts);
      SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1)
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };
  
  const shifts = shiftsState; // data?.shiftsByUser?.items;

  if (loading || loadingUser) {
    return (
      <div className="spinnerContainer">
          <Spinner animation="border" role="status" className="spinner">
              <span className="visually-hidden">Loading...</span>
          </Spinner>   
      </div>
    )
  };

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }
  // WEEK VIEW CALENDAR

  // Calcule le début et la fin de la semaine actuelle
  const startWeek = startOfWeek(currentWeek, { weekStartsOn: 1, locale: getLanguage() });
  const endWeek = endOfWeek(currentWeek, { weekStartsOn: 1, locale: getLanguage() });

  // Navigation entre les semaines
  const nextWeek = () => {
    setPageTokens([null]);
    setTotalPagination(1);
    setCurrentPageIndex(1);
    setHasMorePages(true);
    setDontUpdateAnymore(false);
    setShiftsState([]);
    setCurrentWeek(addWeeks(currentWeek, 1));
  };

  const prevWeek = () => {
    setPageTokens([null]);
    setTotalPagination(1);
    setCurrentPageIndex(1);
    setHasMorePages(true);
    setDontUpdateAnymore(false);
    setShiftsState([]);
    setCurrentWeek(subWeeks(currentWeek, 1));
  };

  const fromMonthCalendar = (date: any) => {
    setPageTokens([null]);
    setTotalPagination(1);
    setCurrentPageIndex(1);
    setHasMorePages(true);
    setDontUpdateAnymore(false);
    setShiftsState([]);
    if (date instanceof Date) {
      setCurrentWeek(date); // ✅ Une seule date sélectionnée
    } else if (Array.isArray(date) && date[0] instanceof Date) {
      setCurrentWeek(date[0]); // ✅ Plage de dates : on prend le début
    }
  }

  const events = shifts.map((shift) => ({
    shiftId: shift.shiftId,
    userId: shift.userId,
    username: shift.username,
    role: shift.role,
    info: shift.info,
    location: shift.location,
    startAt: shift.startAt,
    stopAt: shift.stopAt,
  }));

  const matchShiftDate = (events: any[], fullDate: string ) => {
    // Vérifiez si un des éléments de shifts correspond à fullDate
    // return events.some(shift => format(new Date(shift.startAt), "yyyy-MM-dd", {locale: getLanguage()}) === fullDate);
    return events.some((shift) => {
      const startAt = new Date(shift.startAt);
      startAt.setHours(startAt.getHours() - TIMEZONE);
      return format(new Date(startAt), "yyyy-MM-dd", {locale: getLanguage()}) === fullDate;
    });
    // const hasMatchingShift = events.some(shift => shift.startAt === fullDate);
    // return hasMatchingShift;
    // return (
    //   <div className={`formattedDate ${hasMatchingShift ? 'highlight' : ''}`}>
    //     {/* Le reste du contenu de votre div */}
    //     <p>Contenu de la date formatée</p>
    //   </div>
    // );
  };

  const fromNow = (startAt: string, stopAt: string) => {
    const alreadyStarted = isNowGreater(new Date(startAt), TIMEZONE);
    const alreadyDone = isNowGreater(new Date(stopAt), TIMEZONE);
    // console.log(getDateTimeWithTimezone(new Date().toISOString(), TIMEZONE));

    // return formatDistanceToNow(new Date(getDateTimeWithTimezone(
    //   alreadyStarted && alreadyDone ? stopAt : startAt, 
    //   TIMEZONE*-1)), { addSuffix: true, locale: getLanguage()});
      //.locale(locale).fromNow()}
    return formatDistanceToNow(new Date(
      alreadyStarted && alreadyDone ? stopAt : startAt), 
      { addSuffix: true, locale: getLanguage()});
      
      // new Date(date), { addSuffix: true, locale: getLanguage()});
  };
  
  // Fonction pour faire défiler jusqu'à un jour spécifique
  const goToDate = (date: string) => {
    const container = document.getElementById("shiftsContainer"); // Récupère l'élément qui doit scroller
    if (!container) return;

    const target = container.querySelector(`[data-date="${date}"]`);
    if (target) {
      container.scrollTo({
        top: (target as HTMLElement).offsetTop - (listRef.current as HTMLElement).offsetTop, // Assurer un bon alignement
        behavior: "smooth",
      });
    }
    // if (listRef.current) {
    //   const target = listRef.current.querySelector(`[data-date="${date}"]`);
    //   if (target) {
    //     listRef.current.scrollTo({
    //       top: (target as HTMLElement).offsetTop - (listRef.current as HTMLElement).offsetTop, // Position relative au conteneur
    //       behavior: "smooth",
    //     });
    //   }
    // }
    // if (listRef.current) {
    //   const target = listRef.current.querySelector(`[data-date="${date}"]`);
    //   if (target) {
    //     target.scrollIntoView({ behavior: "smooth", block: "start" }); // Défilement doux, aligne en haut
    //   }
    // }
  };

  const getInfo = (title: string, body: string) => {
    setContentModal(<><Modal.Header closeButton>
    <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{body}</p>
      </Modal.Body></>);
    setShowCustomModal(true);
  }

  const goToShift = (id: string) => {
      navigate(t('link.shift') + '/' + id);
  } 

  return (
    <>
    {/* <style>
      {`
        html, body {
          overflow: hidden;
        }
      `}
    </style> */}
    <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
    <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3 pt-5">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="outline-primary" style={{alignSelf: "center"}} onClick={() => setShowMonthCalendar(!showMonthCalendar)}>
              {t('agenda.selectDate')}
            </Button>
          </div>
          <div className="scheduler-container">
            <div style={{ textAlign: "center" }}>
              {showMonthCalendar ? (
                <div className="my-3 d-flex justify-content-center">
                  <Calendar
                    onChange={(date) => {
                      setShowMonthCalendar(false); // Fermer le calendrier
                      fromMonthCalendar(date);
                      // if (date instanceof Date) {
                      //   setCurrentWeek(date); // ✅ Une seule date sélectionnée
                      // } else if (Array.isArray(date) && date[0] instanceof Date) {
                      //   setCurrentWeek(date[0]); // ✅ Plage de dates : on prend le début
                      // }
                    }}
                    value={currentWeek}
                    locale={savedLang || 'en'}
                    calendarType="iso8601"
                  />
                </div>
              ) : (
                <>
                  {/* Navigation des semaines */}
                  <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                    <div onClick={prevWeek} style={{ cursor: "pointer" }}><AiFillLeftCircle size={60} className="hover-icon"/></div>
                    <h2>{format(startWeek, "dd MMM", {locale: getLanguage()})} - {format(endWeek, "dd MMM yyyy", {locale: getLanguage()})}</h2>
                    <div onClick={nextWeek} style={{ cursor: "pointer" }}><AiFillRightCircle size={60} className="hover-icon"/></div>
                  </div>

                  {/* Liste des jours de la semaine */}
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "10px" }}>
                    {Array.from({ length: 7 }).map((_, i) => {
                      const dayFormatted = format(addDays(startWeek, i), "EEE", {locale: getLanguage()}); // Nom abrégé du jour (Mon, Tue, etc.)
                      let dateFormatted = format(addDays(startWeek, i), "d", {locale: getLanguage()}); // Numéro du jour du mois
                      const fullDate = format(addDays(startWeek, i), "yyyy-MM-dd", {locale: getLanguage()}); // Date complète au format ISO

                      return (
                        <div key={i} onClick={() => goToDate(fullDate)} style={{ cursor: "pointer", textAlign: "center" }}>
                          <div style={{ fontWeight: "bold" }}>{dayFormatted}</div>
                          <div className={`formattedDate ${matchShiftDate(events, fullDate) ? 'markedDate' : ''}`}
                            // style={{
                            //   display: "inline-block", // Utiliser inline-block pour que le contenu s'ajuste à la taille
                            //   width: "40px", // Fixer la largeur de la boîte
                            //   height: "40px", // Fixer la hauteur de la boîte pour un cercle
                            //   lineHeight: "40px", // Centrer verticalement
                            //   borderRadius: "50%", // Faire un cercle
                            //   backgroundColor: "#f0f0f0", // Couleur de fond
                            //   textAlign: "center", // Centrer le texte horizontalement
                            //   fontSize: "16px", // Ajuster la taille de la police
                            // }}
                          > {dateFormatted} </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              {/* Liste des événements scrollable */}
              <div
                id="shiftsContainer"
                ref={listRef}
                // style={{
                //   maxHeight: "500px", // Limite la hauteur pour permettre le défilement
                //   overflowY: "scroll",
                //   borderTop: "1px solid #ccc",
                //   padding: "10px",
                //   marginBottom: "20px",
                // }}
              >
                <Stack direction="vertical" gap={3} >
                {events.length === 0 ? (
                  <div style={{ marginBottom: "10px" }}>
                    {t('agenda.noShift')}
                  </div>
                ) : (
                  events.map((event, index) => {
                    const theDay = new Date(event.startAt);
                    const eventDay = format(new Date(theDay).setHours(theDay.getHours() - TIMEZONE), "yyyy-MM-dd", {locale: getLanguage()}); // Formater la date du jour
                    const eventStarAt =  new Date(events[index === 0 ? 0 : index - 1].startAt);
                    eventStarAt.setHours(eventStarAt.getHours() - TIMEZONE);
                    const startAt = new Date(event.startAt);
                    startAt.setHours(startAt.getHours() - TIMEZONE);
                    const stopAt = new Date(event.stopAt);
                    stopAt.setHours(stopAt.getHours() - TIMEZONE);
                    return (
                      <>
                      <div data-date={eventDay} className="mb-3">
                        {index === 0 || format(eventStarAt, "yyyy-MM-dd", { locale: getLanguage() }) !== eventDay ? (
                          <h4 className="mb-3">{format(startAt, "EEEE d MMMM", { locale: getLanguage() })}</h4>
                        ) : null}

                        <div className="p-3 bg-light border rounded-4 shadow-sm">
                          <div className="row align-items-start g-3">
                            {/* User info */}
                            <div className="col-md-4 col-12">
                              <div className="text-center p-3">
                                <Link to={`${t('link.user')}/${event.userId}`} className="fw-bold d-block">{event.username}</Link>
                                <span className="text-muted">{fromNow(startAt.toString(), stopAt.toString())}</span>
                              </div>
                            </div>
                            {/* Left info */}
                            <div className="col-md-4 col-12">
                              <div className="bg-white border rounded-4 p-3 h-100">
                                <div className="mb-2">
                                  <strong>{event.role}</strong><br />
                                  <span>{event.location}</span>
                                </div>
                                <div className="mb-2">
                                  {format(startAt, "HH:mm", { locale: getLanguage() })} - {format(stopAt, "HH:mm", { locale: getLanguage() })}
                                </div>
                                <Button className="w-100 mt-2" onClick={() => getInfo(t('agenda.infoTitle'), event.info)}>
                                  {t('agenda.info')}
                                </Button>
                              </div>
                            </div>

                            

                            {/* Icon navigation */}
                            <div className="col-md-4 col-12 text-center d-flex align-items-center justify-content-center align-self-center">
                              <IoArrowRedoCircleOutline
                                onClick={() => goToShift(event.shiftId)}
                                className="hover-icon"
                                size={80}
                                style={{ cursor: 'pointer', justifySelf: 'center' }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                        {/* <div data-date={eventDay}>
                        {index === 0 || format(eventStarAt, "yyyy-MM-dd", {locale: getLanguage()}) !== eventDay ? (
                          <h3>{format(startAt, "EEEE d MMMM", {locale: getLanguage()})}</h3>
                        ) : null}
                        </div>
                        <div key={'shift_' + event.shiftId} className="p-2 flex-fill bg-light border rounded-4" >
                          <Stack direction="horizontal" gap={3} className="align-items-start">
                            <div className="flex-grow-2 p-2 bg-white border rounded-4">
                              <span>{event.role}</span><br />
                              <span>{event.location}</span><br />
                              <div className="flex-grow-1">
                                  {format(startAt, "HH:mm", {locale: getLanguage()})} to {format(stopAt, "HH:mm", {locale: getLanguage()})}
                              </div>
                              <div style={{}}>
                                <Button style={{width: '100%'}}onClick={() => getInfo(t('agenda.infoTitle'), event.info)}>{t('agenda.info')}</Button>
                              </div>
                            </div>
                            <div className="flex-grow-1 p-2">
                              <Stack direction="vertical" gap={3} className="align-items-start">
                                <div className="flex-grow-1 text-start">
                                  <Link to={`${t('link.user')}/${event.userId}`}>
                                  <strong>{event.username}</strong></Link> <br />
                                  <span>{fromNow(startAt.toString())}</span><br />
                                </div>
                              </Stack>
                            </div>
                            <div className="flex-grow-2 p-2">
                              <IoArrowRedoCircleOutline onClick={() => goToShift(event.shiftId)} className="hover-icon" size={80}/>
                            </div>
                          </Stack>
                        </div>  */}
                      </>
                    );
                  })
                )}
                </Stack>
              </div>
            </div>
            <div className="pagination-container">
              <h2 className="paginationTitle">{t('title.shifts')}</h2>
              {/* <p>tokenLenght: {pageTokens.length}</p>
              <p>pageIndex: {currentPageIndex}</p>
              <p>hasMorePages: {hasMorePages.toString()}</p>
              <p>currentPageIndex: {currentPageIndex}</p> */}
              <Pagination
                currentPage={currentPageIndex}
                totalPages={totalPagination}
                hasMorePages={hasMorePages}
                onNext={handleNextPage}
                onPrevious={handlePreviousPage}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Agenda;















